/**
 * GoogleMapsService - Caricamento condiviso delle Google Maps JS API e utility per i link di navigazione
 *
 * La key è pubblica per natura (finisce nel bundle): va protetta con le restrizioni per
 * HTTP referrer sulla console Google Cloud, includendo capacitor://localhost e https://localhost
 * per le app native.
 */

import { Loader } from '@googlemaps/js-api-loader'

const API_KEY = process.env.VUE_APP_GOOGLE_MAPS_KEY || 'AIzaSyDuAp4HjXaWQ5Yv0qDDiZ92M05EoUPXhBM'

// Map ID necessario per gli AdvancedMarkerElement
export const MAP_ID = 'b7fd33aa3ec6c5ac550365c1'

// Centro di default quando non c'è ancora una posizione (Italia)
export const DEFAULT_CENTER = { lat: 42.5, lng: 12.5 }

let loader = null

/**
 * Importa una libreria delle Maps JS API, caricando lo script alla prima chiamata.
 * @param {String} name - 'maps', 'marker', 'places', ...
 * @returns {Promise<Object>}
 */
export const importLibrary = (name) => {
	if (!loader) {
		loader = new Loader({
			apiKey: API_KEY,
			version: 'weekly',
			language: 'it',
			region: 'IT'
		})
	}

	return loader.importLibrary(name)
}

/**
 * Link universale per avviare la navigazione verso un luogo: su desktop apre Google Maps nel
 * browser, su Android/iOS apre l'app Google Maps se installata. Solo con le coordinate: il testo
 * libero è spesso un'etichetta ("Sede Operativa", "DA ... A ...") che porterebbe nel posto sbagliato.
 * @param {Number|String|null} lat
 * @param {Number|String|null} lng
 * @returns {String|null}
 */
export const navigationUrl = (lat, lng) => {
	const present = value => value !== null && value !== undefined && value !== ''

	if (!present(lat) || !present(lng)) {
		return null
	}

	return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng)
}
